import { graphql, Link } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';
import { useScreen } from '../../../hooks/useScreen';
import { useScrollDirection } from '../../../hooks/useScrollDirection';
import { MainHeader } from '../../navigation/header/main';
import { SubHeader } from '../../navigation/header/sub';
import { LOGIN_PAGE, REGISTER_PAGE, CHECKOUT_PAGE, CART_PAGE, FORGOT_PASSWORD } from '../../../constants/page-links';

const pagesWithStickyHeader = [
  LOGIN_PAGE.replaceAll('/', ''),
  REGISTER_PAGE.replaceAll('/', ''),
  CHECKOUT_PAGE.replaceAll('/', ''),
  CART_PAGE.replaceAll('/', ''),
  FORGOT_PASSWORD.replaceAll('/', '')
];

const Header = (props) => {
  const skipToMainContentText = 'Skip to main content';

  const { allOptimizelySiteSettingsContentChildren } = props.data;

  const {
    edges: [
      {
        node: { menu, instagramUrl, twitterUrl, facebookUrl, pinterestUrl }
      }
    ]
  } = allOptimizelySiteSettingsContentChildren;

  const headerRef = useRef(null);

  const scrollDirection = useScrollDirection();
  const { isMobile } = useScreen();
  const [displayMainMenuClass, setDisplayMainMenuClass] = useState(false);
  const [isPagesWithStickyHeader, setPageWithStickyHeader] = useState(false);
  const isPagesWithStickyMainHeader =
    typeof window !== 'undefined'
      ? pagesWithStickyHeader.includes(window.location.pathname.replaceAll('/', ''))
      : false;

  useEffect(() => {
    setPageWithStickyHeader(isPagesWithStickyMainHeader || props.removeScroll);
  }, [props.removeScroll, isPagesWithStickyMainHeader]);

  return (
    <header
      ref={headerRef}
      className={`header transition-for-scroll
      	${isPagesWithStickyHeader ? 'header-pos-sticky' : ''}
				${isMobile && scrollDirection === 'down' ? '-top-24' : 'top-0'}`.trim()}
    >
      <Link className="sr-only" to="/#content">
        {skipToMainContentText}
      </Link>
      <MainHeader
        ref={headerRef}
        menu={menu}
        setDisplayMainMenuClass={setDisplayMainMenuClass}
        displayMainMenuClass={displayMainMenuClass}
      />
      <SubHeader
        ref={headerRef}
        setDisplayMainMenuClass={setDisplayMainMenuClass}
        instagramUrl={instagramUrl}
        twitterUrl={twitterUrl}
        facebookUrl={facebookUrl}
        pinterestUrl={pinterestUrl}
      />
    </header>
  );
};

export default Header;

export const query = graphql`
  query {
    allOptimizelySiteSettingsContentChildren {
      edges {
        node {
          instagramUrl
          twitterUrl
          facebookUrl
          pinterestUrl
          menu {
            contentLink {
              expanded {
                page {
                  id
                  url
                  expanded {
                    contentLink {
                      id
                      url
                    }
                    contentType
                    heading
                    listHeading
                    listImage {
                      expanded {
                        name

                        resourceType
                        resourceSubType
                        width
                        height
                        pixelRatio
                        description
                        contentLink {
                          id
                          url
                        }
                        contentType
                      }
                    }
                    listImageDescription
                    listSubHeading
                    listingMode
                    listingTitle
                    locationType
                    metaDescription
                    metaTitle
                    name
                    themeColor
                    eyeBrow
                    productFilters
                    productsPerRow
                    secondaryListImage {
                      expanded {
                        contentLink {
                          id
                          url
                        }
                        contentType
                        height
                        name
                        width
                        resourceType
                        resourceSubType
                        pixelRatio
                      }
                    }
                  }
                }
                subMenusTop {
                  contentLink {
                    id
                    expanded {
                      contentLink {
                        id
                        url
                      }
                      showInMenu
                      contentType
                      listHeading
                      listImage {
                        expanded {
                          name
                          resourceType
                          resourceSubType
                          width
                          height
                          pixelRatio
                          description
                          contentLink {
                            id
                            url
                          }
                          contentType
                        }
                      }
                      listImageDescription
                      payoff
                      listSubHeading
                      # listingMode
                      # listingTitle
                      metaDescription
                      metaTitle
                      name
                      themeColor
                      # productFilters
                      productsPerRow
                      secondaryListImage {
                        expanded {
                          contentLink {
                            id
                            url
                          }
                          contentType
                          height
                          name
                          width
                          resourceType
                          resourceSubType
                          pixelRatio
                        }
                      }
                    }
                  }
                  displayOption
                }
                subMenusBottom {
                  contentLink {
                    id
                    expanded {
                      contentLink {
                        id
                        url
                      }
                      showInMenu
                      contentType
                      # heading
                      listHeading
                      listImage {
                        expanded {
                          name
                          resourceType
                          resourceSubType
                          width
                          height
                          pixelRatio
                          description
                          contentLink {
                            id
                            url
                          }
                          contentType
                        }
                      }
                      listImageDescription
                      listSubHeading
                      listingMode
                      metaDescription
                      metaTitle
                      name
                      themeColor
                      productFilters
                      productsPerRow
                      secondaryListImage {
                        expanded {
                          contentLink {
                            id
                            url
                          }
                          contentType
                          height
                          name
                          width
                          resourceType
                          resourceSubType
                          pixelRatio
                        }
                      }
                      # topImage {
                      #  expanded {
                      #    contentLink {
                      #      id
                      #      url
                      #    }
                      #    contentType
                      #    height
                      #    width
                      #  }
                      # }
                    }
                  }
                  displayOption
                }
                contentType
                darkenImageTop
                descriptionTop
                disableAutoSubItemsBottom
                disableAutoSubItemsTop
                itemsPerRowBottom
                itemsPerRowTop
                name
                showAllLinkBottom {
                  url
                  text
                  title
                  target
                }
                showAllLinkTop {
                  url
                  text
                  title
                  target
                }
                secondaryLinkTop {
                  url
                  text
                  title
                  target
                }
                textColorBottom
                textColorTop
                titleBottom
                titleTop
              }
            }
            displayOption
          }
        }
      }
    }
  }
`;
